import React from 'react';

const Footer = () => {
    return (
        // footer code modified from original code in https://hrms.iwowsoft.com/iwowhr/ui/security/login.html
        <footer className="footer text-center">
            <div class="logo_container">
                <div>
                    <p>Powered By:&nbsp;
                        <a href="https://www.iwowsoft.com?source=https://hrms.iwowsoft.com/iwowhr/ui/security/login.html?ReturnUrl=%2fiwowhr%2fui%2fself_service.html"> 
                            {/*<span class="logo iwowsoft"></span>*/}
                            <strongs>iWowSoft</strongs>.&nbsp;                
                        </a>
                    </p>
                </div>
                <div>
                    <p>Protected By:&nbsp;
                        <span>
                            <a href="//cloudflare.com" target="_blank">
                                {/*<span class="logo cloudflare_logo"></span>*/}
                                <strongs>Cloudflare</strongs>.
                            </a>
                        </span>
                    </p>
                </div>

                {/*
                <div class="logo_msc_panel">
                    <span class="logo msc"></span>
                </div>
                */}
            </div>
        </footer>
    );
}
export default Footer;
